export default {
  'business-growth': 'Låt ditt företag växa',
}
